var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleads1 = function SvgGoogleads1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2243_200375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F8",
    stroke: "#fff",
    strokeWidth: 1.427,
    d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C8BD9",
    d: "M17.105 13.726c.145-.38.344-.731.64-1.015a2.508 2.508 0 0 1 3.945.586c.604 1.1 1.244 2.175 1.866 3.262l3.118 5.425c.864 1.516-.073 3.431-1.788 3.69-1.052.158-2.036-.325-2.58-1.268l-2.743-4.76q-.028-.053-.066-.097c-.097-.078-.14-.193-.2-.296l-2.017-3.498a2.5 2.5 0 0 1-.332-1.328c.018-.242.048-.484.157-.701"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FABC04",
    d: "M17.105 13.726a3.5 3.5 0 0 0-.115.664 2.6 2.6 0 0 0 .362 1.42l1.988 3.437c.06.103.108.206.169.302l-1.093 1.879-1.529 2.634c-.024 0-.03-.012-.036-.03-.006-.049.012-.09.024-.14.248-.905.042-1.709-.58-2.398a2.3 2.3 0 0 0-1.42-.73c-.725-.103-1.365.084-1.939.537-.102.079-.169.194-.29.254q-.035-.002-.042-.03l.864-1.505 3.594-6.228c.012-.024.03-.042.043-.066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A852",
    d: "m12.628 21.542.345-.308c1.467-1.16 3.672-.32 3.993 1.517.078.44.036.863-.097 1.286a1 1 0 0 1-.024.103c-.054.097-.103.2-.163.296-.538.888-1.33 1.33-2.368 1.263-1.19-.085-2.127-.979-2.29-2.163a2.42 2.42 0 0 1 .332-1.607c.06-.109.133-.205.2-.314.03-.024.018-.073.072-.073"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FABC04",
    d: "M12.628 21.543c-.024.024-.024.066-.066.072-.006-.042.018-.066.042-.096z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1C025",
    d: "M16.845 24.14c-.024-.041 0-.072.024-.102l.024.024z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2243_200375",
    width: 38.83,
    height: 42.685,
    x: 0.219,
    y: 0.113,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2243_200375"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2243_200375",
    result: "shape"
  })))));
};
export default SvgGoogleads1;